/* eslint-disable no-unused-vars */
import adLmiClaims from './ad-lmi-claims.jpg';
import adLmiCollege from './ad-lmi-college.jpg';
import adLmiRiskCoachOtg from './ad-lmi-riskcoach-otg.jpg';
import adWebinar from './ad-webinar.jpg';
import adTyk from './ad-tyk.jpg';
import adSteadfast from './ad-steadfast-bg.jpg';
import adMansfield from './ad-mansfield.jpg';
import adMasterClassAllan from './ad-masterclass-alan.jpg';

export default [
  {
    key: 'lmi-adMasterClassAllan',
    title: 'LIVE BI Masterclass',
    description: 'Presented by Professor Allan Manning',
    link: 'https://lmigroup.io/product/live-business-interruption-bi-masterclass-starts-9-4-prof-allan-manning/',
    cover: adMasterClassAllan,
    button_text: null,
    countries: ['au', 'nz'],
    scope: 'lmi',
  },
  {
    key: 'lmi-adMansfield',
    title: 'Mansfield Awards 2025',
    description: 'Reserve Your Spot Today!',
    link: 'https://mansfieldawards.com.au/shop/',
    cover: adMansfield,
    button_text: null,
    countries: ['au', 'nz'],
    scope: 'lmi',
  },
  {
    key: 'lmi-tyk',
    title: 'Test Your Knowledge',
    description: 'New Feature on RiskCoach!!',
    linkType: 'local',
    link: '/test-your-knowledge',
    cover: adTyk,
    countries: ['au', 'nz'],
    scope: 'lmi',
  },
  {
    key: 'lmi-webinar',
    title: 'Webinar Schedule',
    description: 'Free webinar registration! We want to keep you informed of our upcoming webinar training! ',
    link: 'https://lmigroup.io/webinars',
    cover: adWebinar,
    countries: ['au', 'nz'],
    scope: 'lmi',
  },
  {
    key: 'lmi-claims',
    title: 'LMI Claims Preparation',
    description: 'The best kept secret in Insurance',
    link: 'https://www.lmigroup.io/services/claims',
    cover: adLmiClaims,
    countries: ['au', 'nz'],
    scope: 'lmi',
  },
  {
    key: 'lmi-education',
    title: 'LMI College',
    description: 'Quality accredited technical Insurance training solutions',
    link: 'https://lmigroup.io/introducing-lmi-college-of-insurance-and-risk/',
    cover: adLmiCollege,
    countries: ['au', 'nz'],
    scope: 'lmi',
  },
  {
    key: 'lmi-riskcoach-otg',
    title: 'RiskCoach OnTheGo',
    description: 'RiskCoach OnTheGo V2 out now!',
    link: 'https://lmigroup.io/eservices/riskcoach/#Portable',
    cover: adLmiRiskCoachOtg,
    button_text: 'Download the App',
    countries: ['au', 'nz', 'gb'],
    scope: 'lmi',
  },
  {
    key: 'steadfast-ad',
    title: 'Can we help improve your client’s risk profile?',
    description: ' Discover Steadfast Risk Group’s comprehensive suite of risk solutions.',
    link: 'https://broker.steadfast.com.au/broker-centre/steadfast-risk-group/',
    cover: adSteadfast,
    button_text: 'LEARN MORE',
    countries: ['au', 'nz', 'gb'],
    scope: 'iprofile',
  },
];
